import Swiper from 'swiper';
import { MAP_CONTENT_CLASS, initMaps } from '@/lib/components/kakao_map';

// Declaration
let currentIndex;

function currentTab() {
  return document.getElementsByClassName('tab-content')[currentIndex];
}

// Switch between Tabs
function switchTab(index) {
  // if (currentIndex === index) return;
  currentIndex = index;

  // TabList
  const tabLists = document.getElementsByClassName('tab-list');
  for (const list of tabLists) list.classList.remove('active');
  if (tabLists[index]) tabLists[index].classList.add('active');

  // TabContent
  const tabContents = document.getElementsByClassName('tab-content');
  for (const content of tabContents) content.classList.remove('active');
  if (tabContents[index]) tabContents[index].classList.add('active');

  // ActionButtons
  const tabActions = document.getElementsByClassName('fixed-action-buttons');
  for (const action of tabActions) if (action) action.classList.remove('active');
  if (tabActions[index]) tabActions[index].classList.add('active');

  // Relayout MAP if Exists
  const mapObject = document.querySelectorAll(MAP_CONTENT_CLASS)[index]?.mapObject;
  if (mapObject) {
    mapObject.relayout();
    mapObject.panTo(mapObject.center);
  }

  // Init Intro Swiper
  currentTab()?.querySelectorAll('.intro-swiper').forEach(e => {
    if (!e.swiper && e.offsetWidth !== 0) {
      new Swiper(e, {
        slidesPerView: 1.5,
        spaceBetween: 8
      });
    }
  });

  document.querySelector('.themes-root').dataset.index = index;
}

// onScroll
const fixedActionBtns = document.getElementsByClassName('fixed-action-buttons');
let btnActiveY;
let buttonsActive = false;

function refreshY() {
  // 하단 버튼 표시할 Y값
  btnActiveY = document.querySelector('.tab-content .buttons').getBoundingClientRect().y + window.scrollY;
  // 네비바 타이틀 표시할 Y값
  window.navTitleY = document.getElementById('theme-title').getBoundingClientRect().y + window.scrollY;
}

// onload
onload(() =>{
  const index = parseInt(document.querySelector('.themes-root')?.dataset?.index || '0');
  const themeId = document.querySelector('.themes-root')?.dataset?.themeId;

  // console.log(themeId)
  if (themeId) {
    window.kp?.viewContent({
      tag: themeId
    })
  } else {
    window.kp?.viewContent()
  }

  // console.log(index);
  switchTab(index);
  refreshY();

  window.addEventListener('resize', function(e) { refreshY(); });
  
  window.addEventListener('scroll', function(e) {
    const activate = window.scrollY > btnActiveY;
  
    if (activate && !buttonsActive) {
      for (const btn of fixedActionBtns) btn.classList.remove('hide');
      buttonsActive = true;
    } else if (!activate && buttonsActive) {
      for (const btn of fixedActionBtns) btn.classList.add('hide');
      buttonsActive = false;
    }
  });

  // 버튼 링크
  // 테마 소개 이동
  document.querySelector('.themes-root .header a').addEventListener('click', e => {
    const currentTab = document.getElementsByClassName('tab-content')[currentIndex];
    $('html,body').animate({
      scrollTop: currentTab.querySelector('.intro').offsetTop - 55
    }, 'slow');
  });

  initMaps();

  // 탭 리스트
  document.querySelectorAll('li.tab-list').forEach((e, i) => {
    e.addEventListener('click', evt => {
      switchTab(i);
    });
  });

  document.querySelectorAll('div.map-container > .header').forEach((e) => {
    e.addEventListener('click', evt => {
      e.mapObject?.panTo(e.mapObject?.center);
    });
  });

  window.scrollTo(0, 0);
// });
}, {});